import { LogoWrapper } from "./LogoWrapper";

export default LogoWrapper;
